import { RouteLocationNamedRaw } from 'vue-router';
import { IEmbeddedStateMutable } from '@/url/IEmbeddedStateMutable';
import { FilterKey } from '@studyportals/search-filters';

export class NavigationTargetResult {
	public readonly navigationTarget: RouteLocationNamedRaw;
	public remainingEmbeddedState: IEmbeddedStateMutable;

	public constructor(navigationTarget: RouteLocationNamedRaw, remainingEmbeddedState: IEmbeddedStateMutable) {
		this.navigationTarget = navigationTarget;
		this.remainingEmbeddedState = remainingEmbeddedState;
	}

	public remove(key: FilterKey, value: string): void {
		const remainingFilterSelection = this.remainingEmbeddedState.filterSelectionState.removeFor(key, value);
		this.remainingEmbeddedState.withFilterSelection(remainingFilterSelection);
	}
}
